import { useState } from "react";

import { useNavigate } from "react-router-dom";

import MenuIcon from "../../../../assets/icons/Menu-icon.png";
import { Button } from "../Button";

import { getDevice } from "@/utils/device";
import { Calendar, Headphones, LogOut, Settings } from "lucide-react";
import { useIntercomVisibility } from "../../../../hooks/useIntercomVisibility";
import { useUserContext } from "../../../../hooks/useUserContext";
import { dmnIdentity } from "../../../../utils/dmnIdentity";
import { isNativeTab } from "../../../../utils/environment";
import { Avatar, AvatarFallback } from "../../../ui/avatar";
import { Sheet, SheetContent, SheetTrigger } from "../../../ui/sheet";

export const MenuButton = () => {
  const userContext = useUserContext();
  const [debugCounter, setDebugCounter] = useState(0);
  const {
    isVisible: isSupportVisible,
    toggleVisibility: toggleSupportVisibility
  } = useIntercomVisibility();

  const device = getDevice();

  // Navigation bar is always enabled on desktop, so hide mobile menu on desktop
  const showMobileMenu = device !== "desktop";

  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const goTo = (page: string) => {
    setOpen(false);
    navigate(`${page}`);
  };

  const openMenu = () => {
    setOpen(true);
  };

  if (!showMobileMenu) {
    return null;
  }

  return (
    <div className="MenuButton ml-3">
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <Button name="Main menu" fill="clear" onClick={openMenu}>
            <img
              src={MenuIcon}
              className="MenuIcon h-3 w-4 mt-[3px]"
              alt="MenuIcon"
            />
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="w-[300px] sm:w-[400px]">
          {!isNativeTab() ? (
            <div className="user-profile mb-6 ml-[var(--panelPadding)]">
              <Avatar className="user-profile__avatar h-[60px] w-[60px]">
                <AvatarFallback>
                  {(userContext.user?.first_name ?? "").substring(0, 1) +
                    (userContext.user?.last_name ?? "").substring(0, 1)}
                </AvatarFallback>
              </Avatar>
              <div className="user-profile__text mt-2">
                <h3 className="user-profile__name font-semibold">
                  {`${userContext.user?.first_name} ${userContext.user?.last_name}`.trim()}
                </h3>
                {userContext.user?.email && (
                  <p className="user-profile__email text-sm text-muted-foreground">
                    {userContext.user?.email}
                  </p>
                )}
              </div>
            </div>
          ) : null}

          <div className="flex flex-col space-y-2">
            <button
              className="flex items-center space-x-3 p-3 rounded-md hover:bg-accent"
              onClick={() => goTo("/diary")}
            >
              <Calendar className="size-5 text-green-600" />
              <span>Diary</span>
            </button>
            <button
              className="flex items-center space-x-3 p-3 rounded-md hover:bg-accent"
              onClick={() => goTo("/settings")}
            >
              <Settings className="size-5 text-green-600" />
              <span>Settings</span>
            </button>
            <button
              className="flex items-center space-x-3 p-3 rounded-md hover:bg-accent"
              onClick={toggleSupportVisibility}
            >
              <Headphones className="size-5 text-green-600" />
              <span>{isSupportVisible ? "Hide Support" : "Show Support"}</span>
            </button>
            {!isNativeTab() ? (
              <button
                className="flex items-center space-x-3 p-3 rounded-md hover:bg-accent"
                onClick={dmnIdentity.signOut}
              >
                <LogOut className="size-5 text-green-600" />
                <span>Sign Out</span>
              </button>
            ) : null}
            <button
              style={{ opacity: 0 }}
              className="flex items-center space-x-3 p-3 rounded-md hover:bg-accent"
              onClick={() => {
                setDebugCounter(debugCounter + 1);

                if (debugCounter > 9) {
                  navigate("/debug");
                  setOpen(false);
                  setDebugCounter(0);
                }
              }}
            >
              <span>Show debug</span>
            </button>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
};
